import * as R from "ramda";

import {
  getNotifications,
  getNotificationsExceptUnlock,
} from "../selectors/notifications";

export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
export const REMOVE_NOTIFICATIONS = "REMOVE_NOTIFICATIONS";

export const addNotifications = (notifications) => ({
  type: ADD_NOTIFICATIONS,
  payload: notifications,
});

export const hideNotifications = (notifications) => ({
  type: REMOVE_NOTIFICATIONS,
  payload: notifications,
});

export const showNotification = (notification) => (dispatch, getState) => {
  const currentNotifications = getNotifications(getState());
  const key =
    notification.key || `${currentNotifications.length}${new Date().getTime()}`;
  const hide = () => dispatch(hideNotifications([key]));

  dispatch(
    addNotifications({ key, onClose: hide, onConfirm: hide, ...notification })
  );

  return hide;
};

export const hideNotificationsExceptUnlock = () => (dispatch, getState) => {
  const notifications = getNotificationsExceptUnlock(getState());
  dispatch(hideNotifications(R.pluck("key", notifications)));
};
